module.exports = __webpack_public_path__ + "img/16f.d8222170.png";